/* eslint-disable camelcase */
export default {
	customerName: '客户名称',
	businessIncome1: '营业收入(万元)/2021年',
	businessIncome2: '营业收入(万元)/2020年',
	businessIncome3: '营业收入(万元)/2019年',
	businessProfits1: '营业利润(万元)/2021年',
	businessProfits2: '营业利润(万元)/2020年',
	businessProfits3: '营业利润(万元)/2019年',
	assetsTotal1: '资产总额(万元)/2021年',
	assetsTotal2: '资产总额(万元)/2020年',
	assetsTotal3: '资产总额(万元)/2019年',
	debtTotal1: '负债总额(万元)/2021年',
	debtTotal2: '负债总额(万元)/2020年',
	debtTotal3: '负债总额(万元)/2019年',
	cooperateYears: '合作年限',
	growthRate: '行业5年增长率(%)',
	isSystemObtainName: '是否由系统获取历史收入/回款率(%)',
	clientType: '客户类型',
	tsa: '历史收入(元)',
	rvr: '回款率(%)',
	customerNatureName: '企业性质',
	foundYears: '成立年限',
	employeeNum: '员工人数',
	propertyStatusName: '产权状况',
	salesAreaName: '销售目的地',
	negativeInfoNum: '负面信息记录数(作为被告)',
	holderBackgroundName: '控股股东背景',
	legalPersonCreRatingName: '法人代表个人信用评价',
	actIncomeCapital: '实收资本(万元)',
	debtRate3: 'N-3资产负债率(%)',
	debtRate2: 'N-2资产负债率(%)',
	debtRate1: 'N-1资产负债率(%)',
	netMargins3: 'N-3净利润率(%)',
	netMargins2: 'N-2净利润率(%)',
	netMargins1: 'N-1净利润率(%)',
	netAssets3: 'N-3净资产(万元)',
	netAssets2: 'N-2净资产(万元)',
	netAssets1: 'N-1净资产(万元)',
	receivableDays: '应收账款周转天数',
	netAssetsIncome3: 'N-3净资产收益率(%)',
	netAssetsIncome2: 'N-2净资产收益率(%)',
	netAssetsIncome1: 'N-1净资产收益率(%)',
	netMarginsGrowth1: 'N-1净利润增长率(%)',
	totalAssetsGrowth1: 'N-1总资产增长率(%)',
	profitability: '盈利能力',
	operatingIncome: 'N-1营业收入(USD)',
	countryRisk: '国家风险系数',
	reviseIndex1: '外部信用评估',
	reviseIndex2: '股权关联关系',
	reviseIndex3: '股权结构',
	negativeIndex1: '与腾讯交易违规行为',
	negativeIndex2: '异常经营',
	negativeIndex3: '行政处罚记录',
	negativeIndex4: '资产抵押/股权出质记录',
	negativeIndex5: '公司法院失信被执行人信息',
	copyNewOrder: '复制新单',
	indexInvalidSuccess: '批量删除成功',
	indexConfirmSuccess: '批量确认成功',
	basicInformation: '基本信息',
	indexInformation: '指标信息',
	indexId: '指标单号',
	applyId: '申请单号',
	evaluateId: '结果单号',
	status: '状态',
	updateDate: '操作时间',
	source: '指标来源',
	platformName: '业务平台',
	modelName: '模型类型',
	submit: '提交',
	submitSuccess: '提交成功',
	pleaseSelectCustomer: '请选择客户',
	select: '查找',
	pleaseSelect: '请选择',
	pleaseInput: '请输入',
	noEmpty: '不能为空',
	batchImport: '批量导入',
	pleaseSelectFile: '请选择文件',
	indexFileTemplate: '批量信用申请导入模板',
	fileUpload: '附件上传',
	itIsRecommendedToGenerateCreditApplicationsInBatches: '批量确认模型导入如果超过100行，建议分批生成信用申请。',
	selectedFileName: '已选文件名',
	importView: '预览',
	importViewList: '预览信息列表',
	pleaseSelectUploadFile: '请点击选择上传文件',
	pleaseSelectModel: '请选择模板类型',
	pleasePreviewBeforeSubmit: '请先预览后再提交',
	totalUpload: '共上传',
	pen: '笔',
	successfulMatch: '成功匹配',
	indexNum: '序号',
	verificationResults: '验证结果',
	pass: '通过'
};
